import React, { useState, useContext, Fragment, useEffect } from "react";
import { useForm } from "react-hook-form";
import { FormWrapper, TitleIcon, FlexWrapper } from "@app/components/commonStyles";
import { Dialog, Button, Toast, Icon } from "@app/components";
import { createUser, DataService, generateStudentPassword, generateStudentUsername, linkParentChild } from "@app/services";
import { AuthContext } from "@app/providers";
import { getValuesOnly, chatOptions, useLocation, ALPHA_NUMERIC, USERNAME_CHAR_COUNT } from "@app/utils";
import {
  ButtonContainer,
  DialogFooter,
  ConfirmationContentWrapper,
  ConfirmationContent,
} from "./addChild-component";
import AddChildContent from "./addChild-content";
import { Support } from "@app/assets";

type Props = {
  onClose: (e: any) => void;
  setUserDetails: (e: any) => void;
  userDetails: any;
};

export default function AddChild({ onClose, setUserDetails, userDetails }: Props) {
  const {
    register,
    errors,
    control,
    getValues,
    trigger,
    watch,
    handleSubmit,
    setValue,
    clearErrors,
  }: any = useForm({
    mode: "onBlur",
  });

  const { userInfo, setUserInfo } = useContext(AuthContext);
  const { navigate } = useLocation();
  const [childData, SetChildData] = useState<any>({
    childAccount: {},
    childDetails: {},
  });
  const [selectedTab, setSelectedTab] = useState(1);
  const [buttonText, setButtonText] = useState<string>("Link Child");
  const [showToast, setShowToast] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [zipError, setZipError] = useState<boolean>(false);
  const [childPassword, setChildPasword] = useState<String>('')
  const [childUsername, setChildUsername] = useState<String>('')
  const [dialogTitle, setDialogTitle] = useState<string>(
    "Create Child Account"
  );
  const [toastMessage, setToastMessage] = useState<any>({
    type: "",
    message: "",
  });
  const [toastErr, setToastErr] = useState('');
  const [spinner, setSpinner] = useState(false);
  const [studentPassword, setStudentPassword] = useState<any>({
    password: "",
  });
  const [studentUsername, setStudentUsername] = useState<any>({
    username: "",
  });
  const [studentInputDatas, setStudentInputDatas] = useState<any>({
    studentInputData: "",
  });
  
  const base64 = require('base-64');

  useEffect(() => {
    if(studentInputDatas.studentInputData){
      const userData: any = { 
          ...userInfo,
          userJson : {
            ...userInfo.userJson,
            childInputDatas : studentInputDatas.studentInputData
          }
      };
      setUserDetails(userData.userJson)
    }
    if(studentUsername.username){
      const userData: any = { 
          ...userInfo,
          userJson : {
            ...userInfo.userJson,
            childUsername : studentUsername.username
          } 
      };
      setUserDetails(userData.userJson)
    }
    if(studentPassword.password){
      const userData: any = { 
          ...userInfo,
          userJson : {
            ...userInfo.userJson,
            childPassword : studentPassword.password
          } 
      };
      setUserDetails(userData.userJson)
    }
  },[studentInputDatas,studentUsername,studentPassword])


  function generateUsername(data: any) {
    const alphanumeric = ALPHA_NUMERIC;
    let randomUsername = "";
    for (let i = 0; i < USERNAME_CHAR_COUNT; i++) {
      const randomChar = alphanumeric[Math.floor(Math.random() * alphanumeric.length)];
      randomUsername += randomChar;
    }
    let childUsername = randomUsername;
    setStudentUsername({
      username: childUsername
    });
    setChildUsername(childUsername);
  }

  function generatePassword() {
    const params: any = {};
    Object.assign(params, {
      sessionToken: userInfo.sessionToken,
      userId: userInfo && userInfo.userJson.userId,
      update: 0
    });
    generateStudentPassword(params)
      .then((res: any) => {
        const response = res;
        if (response._responseStatus === 1) {
          let childPassword = base64.decode(response.studentPassword)
          setStudentPassword({
            password: childPassword
          });
          setChildPasword(childPassword)
          setToastMessage({
            type: "success",
            message: "Student Password updated Successfully",
          });
        }
        else {
          setToastMessage({
            type: "error",
            message: "Failed to reset Password",
          });
        }
      })
      .catch((err) => {
        console.log(err)
        setToastMessage({
          type: "error",
          message: "Something went wrong",
        });
      })
  }

  const handleRefresh = () => {
    window.location.reload();
  };

  function onSubmit(data: any) {
    if (zipError) return;
    if (selectedTab === 1) {
      setSpinner(true)
      //childAccountLink(data);
      SetChildData({ ...childData, childAccount: data });
      setSelectedTab(selectedTab + 1);
      setDialogTitle("Child Credentials");
      setButtonText("Continue");
      setStudentInputDatas({
        studentInputData: data
      });
      generateUsername(data);
      generatePassword()
      setSpinner(false)
    } else if (selectedTab === 2) {
      SetChildData({ ...childData, childDetails: data });
      setSelectedTab(selectedTab + 1);
      setDialogTitle("Account Settings");
      setButtonText("Add Child");
    } else {
      const { childAccount = {}, childDetails = {} } = childData;
      const subjectValues: any = getValuesOnly(data.subject);
      const params: any = {};
      Object.assign(params, {
        userType: "student",
        homeAccountReg: 1,
        firstName: childAccount.firstName,
        lastName: childAccount.lastName,
        birthMonth: childAccount.birthMonth.value,
        birthYear: childAccount.birthYear.value,
        userGrade: childAccount.grade.value,
        city: userDetails.city ? userDetails.city : "" ,
        state: userDetails.state ? userDetails.state : ""  ,
        zip: userDetails.zip ? userDetails.zip : "",
        email: childDetails.email,
        password: childPassword,
        confirmPassword: childPassword,
        parentId: userInfo.userJson.userId,
        sessionToken: userInfo.sessionToken,
        childPlayOption: data.childPlayOption,
        childMayUse: chatOptions[0].id,
        levelPreference: data.levelPreference,
        subject: subjectValues,
        subscriptionPlans: data.subscriptionOption,
        termsOfService: 1,
      });
      setButtonText("Adding Child...");
      createUser(params)
        .then((response: any) => {
          setButtonText("Add Child");
          if (response._responseStatus) {
            const {
              userJson: { childDetails },
            } = userInfo;
            const childData =
              childDetails && childDetails.length
                ? childDetails.concat(response.userJson)
                : [response.userJson];
            const parentData: any = {};
            Object.assign(parentData, {
              ...userInfo.userJson,
              childDetails: childData,
            });
            const userData: any = { ...userInfo, userJson: parentData };
            DataService.sendMessage({
              key: "userJson",
              data: userData.userJson,
            });
            localStorage.setItem("userData", JSON.stringify(userData));
            setUserDetails(userData.userJson);
            setUserInfo(userData);
            setToastMessage({
              type: "success",
              message: "Child account added successfully",
            });
            setShowToast(true);
            handleRefresh();
            onClose(false);
          } else {
            setToastMessage({
              type: "error",
              message: response.msg,
            });
            setShowToast(true);
          }
        })
        .catch((err: any) => {
          console.log(err);
          setButtonText("Add Child");
          setToastMessage({
            type: "error",
            message: "Something went wrong, Please try again",
          });
          setShowToast(true);
        });
    }
  }

  function onChange(data: any) {
    setToastErr('')
    if (data.target.name === "zip") {
      setValue("city", "");
      setValue("state", "");
      if (data.target.value.length === 5) {
        setZipError(false);
      }
    }
  }
  function Cancel() {
    if (selectedTab === 1) {
      onClose(false)
    } else if (selectedTab === 2) {
      setSelectedTab(selectedTab - 1)
      // SetChildData({ ...childData, childDetails: data });
    } else if (selectedTab === 3) {
      // SetChildData({ ...childData, childDetails: data });/
      setSelectedTab(selectedTab - 1)
    }
  }
  if (!showError) {
    return (
      <Dialog
        onClose={onClose}
        title={dialogTitle}
        className="dialog-with-form"
      >
        <form onSubmit={handleSubmit(onSubmit)} onChange={onChange}>
          <FormWrapper className="form-in-dialog">
            <AddChildContent
              selectedTab={selectedTab}
              register={register}
              errors={errors}
              control={control}
              getValues={getValues}
              trigger={trigger}
              watch={watch}
              setValue={setValue}
              zipError={zipError}
              setZipError={setZipError}
              clearErrors={clearErrors}
              toastErr={toastErr}
              userDetails={userDetails}
              childPassword={setChildPasword}
              childUsername = {setChildUsername}
              spinner={spinner}
            />
          </FormWrapper>
          <DialogFooter>
            <FlexWrapper className="row-on-mobile">
              <Button
                variant="text"
                customClass="mr-1 mr-sm-0 mb-sm-1"
                type="button"
                onClick={() => Cancel()}
              >
                Cancel
              </Button>
              <ButtonContainer
                disabled={
                  buttonText === "Adding Child..." || buttonText === "Linking..."
                }
              >
                <Button variant="newsecondary" type="submit">
                  {buttonText}
                </Button>
              </ButtonContainer>
            </FlexWrapper>
          </DialogFooter>
        </form>
        <Toast
          message={toastMessage.message}
          showToast={showToast}
          type={toastMessage.type}
          title="Link Child"
          onClose={() => setShowToast(false)}
        />
      </Dialog>
    );
  } else {
    return (
      <Dialog onClose={onClose} noTitle={true}>
        <Fragment>
          <ConfirmationContentWrapper className="w-600">
            <div className="d-flex align-items-center mb-2">
              <TitleIcon className="icon-in-title mr-8">
                <Icon name="exclamation" />
              </TitleIcon>
              <h4 className="secondary-header m-0">Child Account Exists</h4>
            </div>
            <ConfirmationContent>
              <p className="confirmation-content mr-4">
                An account already exists for another child with the same email
                address. If this is your child's email address please contact
                support so we can fix the issue.
              </p>
              <img src={Support} alt="" />
            </ConfirmationContent>
          </ConfirmationContentWrapper>
          <DialogFooter className="alt-padding">
            <Button variant="newsecondary" onClick={onClose}>
              Okay
            </Button>
          </DialogFooter>
        </Fragment>
      </Dialog>
    );
  }
}
